import React from 'react';
import './Pages.css';

const GalleryPage = ({ openLightbox }) => {
  const teamMembers = {
    leadership: [
      { name: 'Mr. Isaac K. Gator', role: 'Chief Executive Officer (CEO) • Visionary Leader', img: '/images/ceo.png', caption: 'Mr. Isaac K. Gator • Chief Executive Officer (CEO) • Visionary Leader' },
      { name: 'Abraham AB', role: 'Head of Human Resources • People & Culture', img: '/images/ab.png', caption: 'Abraham AB • Head of Human Resources • People & Culture' },
      { name: 'Savior Malulu', role: 'Chief Accountant • Financial Integrity', img: '/images/savior.png', caption: 'Savior Malulu • Chief Accountant • Financial Integrity' },
    ],
    agents: [
      { name: 'Fello Freedom', role: 'Senior Field Agent • Volta Region Lead', img: '/images/field-agent.jpg', caption: 'Fello Freedom • Senior Field Agent • Volta Region Lead' },
      { name: 'Mr. Abraham AB', role: 'Community Liaison Agent • Customer Relations', img: '/images/liaison-agent.jpg', caption: 'Mr. Abraham AB • Community Liaison Agent • Customer Relations' }
    ]
  };

  return (
    <div className="container fade-in-up">
      <div className="section-title">Meet Our Team</div>
      <p className="justify-text gallery-intro">The dedicated professionals behind I Don't Joke Lottery committed to integrity, transparency, and excellence. Click on any photo to view larger.</p>

      {/* Leadership Section */}
      <div className="team-category">
        <h3 className="category-title"> Leadership</h3>
        <div className="gallery-grid">
          {teamMembers.leadership.map((member, index) => (
            <div key={index} className="gallery-item team-card">
              <img 
                src={member.img} 
                alt={member.name} 
                className="staff-img-real clickable"
                onClick={() => openLightbox(member.img, member.caption)}
                onError={(e) => e.target.src = 'https://placehold.co/400x400/2a274d/FFD966?text=Photo'}
              />
              <div className="caption">{member.name} • {member.role}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Agents Section */}
      <div className="team-category">
        <h3 className="category-title"><i className="fas fa-users"></i> Field Agents & Support</h3>
        <div className="gallery-grid">
          {teamMembers.agents.map((member, index) => (
            <div key={index} className="gallery-item team-card">
              <img 
                src={member.img} 
                alt={member.name} 
                className="staff-img-real clickable"
                onClick={() => openLightbox(member.img, member.caption)}
                onError={(e) => e.target.src = 'https://placehold.co/400x400/2a274d/FFD966?text=Photo'}
              />
              <div className="caption">{member.name} • {member.role}</div>
            </div>
          ))}
          <div className="gallery-item team-card">
            <div className="support-team-placeholder">
              <i className="fas fa-users"></i>
              <span>Team of 15+ Agents</span>
            </div>
            <div className="caption">Dedicated Support Team • 24/7 Customer Service</div>
          </div>
        </div>
      </div>

      <div className="gallery-note">
        <i className="fas fa-camera"></i>
        <p className="justify-text">Click on any staff photo to view larger.</p>
      </div>
    </div>
  );
};

export default GalleryPage;